module.exports = __webpack_public_path__ + "static/media/Date.723df3af.svg";